import * as React from 'react'

import { useNavigate } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { Flex, Text } from '@chakra-ui/react'

import {
  Alert,
  Loading,
  SideMenuLayoutBreadcrumb,
  SideMenuLayoutContentLayout,
} from '@enechain/ecloud-designsystem'

import { CreateApiKeyForm } from '~/pages/ApiKeys/components/CreateApiKeyForm'
import { DuplicateApiKeyForm } from '~/pages/ApiKeys/components/DuplicateApiKeyForm'

type Props = {
  sourceApiKeyId?: string
}

export const ApiKeyCreate: React.FC<Props> = ({ sourceApiKeyId }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <SideMenuLayoutContentLayout
      header={
        <Flex alignItems="center" justifyContent="space-between" width="full">
          <SideMenuLayoutBreadcrumb
            items={[
              {
                label: t('pages.api_keys.title'),
                onClick: () => {
                  void navigate({ to: '/api_keys' })
                },
              },
              {
                label: t('pages.api_keys.create.title'),
                bold: true,
              },
            ]}
          />
        </Flex>
      }
    >
      <Flex
        flexDirection="column"
        gap="6"
        maxWidth="1280px"
        margin="auto"
        padding="2"
      >
        <Flex flexDirection="column" gap="1">
          <Text textStyle="headerLg" color="Text.highEmphasis">
            {t('pages.api_keys.create.title')}
          </Text>
          <Text textStyle="textMd" color="Text.midEmphasis">
            {t('pages.api_keys.create.description')}
          </Text>
        </Flex>
        <Alert status="info">{t('pages.api_keys.create.callout')}</Alert>
        <React.Suspense fallback={<Loading />}>
          {sourceApiKeyId !== undefined ? (
            <DuplicateApiKeyForm sourceApiKeyId={sourceApiKeyId} />
          ) : (
            <CreateApiKeyForm />
          )}
        </React.Suspense>
      </Flex>
    </SideMenuLayoutContentLayout>
  )
}
